module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point03_03_winter-a68c1ec0f2639a9ed1a9fc34d37cf1b1.jpg";